import { module } from 'stereomodularjs';
import { createApp } from "vue/dist/vue.esm-bundler.js"

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;
        const app = createApp({
            components: {},
            data() {
                return {
                    siteId: self.el.dataset.siteid,
                    admissionType: null,
                    admissionStatus: null,
                    admissionTypeChoices: {
                        1: {
                            1: {
                                text: 'Baccalauréat',
                                html: 'pour un <strong>baccalauréat</strong>',
                            },
                            2: {
                                text: 'Certificat',
                                html: 'pour un <strong>certificat</strong>',
                            },
                            3: {
                                text: 'Programme court (1er cycle)',
                                html: 'pour un <strong>programme court (1er cycle)</strong>',
                            },
                            4: {
                                text: 'Maîtrise',
                                html: 'pour une <strong>maîtrise</strong>',
                            },
                            5: {
                                text: 'DESS',
                                html: 'pour un <strong>DESS</strong>',
                            },
                            6: {
                                text: 'Programme court (2e cycle)',
                                html: 'pour un <strong>programme court (2e cycle)</strong>',
                            },
                            7: {
                                text: 'Microprogramme (2e cycle)',
                                html: 'pour un <strong>microprogramme (2e cycle)</strong>',
                            },
                            8: {
                                text: 'Doctorat',
                                html: 'pour un <strong>doctorat</strong>',
                            },
                            9: {
                                text: 'Études libres',
                                html: '',
                            },
                        },
                        2: {
                            1: {
                                text: 'Bachelor\'s degree',
                                html: 'for a <strong>bachelor\'s degree</strong>',
                            },
                            2: {
                                text: 'Certificate',
                                html: 'for a <strong>Certificate</strong>',
                            },
                            3: {
                                text: 'Short program',
                                html: 'for a <strong>short program</strong>',
                            },
                            4: {
                                text: 'Master’s degree',
                                html: 'for a <strong>master’s degree</strong>',
                            },
                            5: {
                                text: 'Specialized Graduate Program',
                                html: 'for a <strong>specialized graduate program</strong>',
                            },
                            6: {
                                text: 'Graduate-level Short Program',
                                html: 'for a <strong>graduate-level short program</strong>',
                            },
                            7: {
                                text: 'Graduate-level Microprogram',
                                html: 'for a <strong>graduate-level microprogram</strong>',
                            },
                            8: {
                                text: 'Doctoral Program',
                                html: 'for a <strong>doctoral Program</strong>',
                            },
                            9: {
                                text: 'Open studies',
                                html: '',
                            },
                        },
                    },
                    admissionStatusChoices: {
                        1: {
                            1: {
                                text: 'Citoyen(ne) canadien(ne) né(e) au Québec',
                                html: '<strong>Citoyen(ne) canadien(ne) né(e) au Québec</strong>',
                            },
                            2: {
                                text: 'Citoyen(ne) du Canada né(e) dans une autre province que le Québec',
                                html: '<strong>citoyen(ne) du Canada né(e) dans une autre province que le Québec</strong>',
                            },
                            3: {
                                text: 'Résident(e) permanent(e)',
                                html: '<strong>résident(e) permanent(e)</strong>',
                            },
                            4: {
                                text: 'Citoyen(ne) canadien(ne) né(e) à l’extérieur du Canada',
                                html: '<strong>citoyen(ne) canadien(ne) né(e) à l’extérieur du Canada</strong>',
                            },
                            5: {
                                text: 'Étudiant(e) international(e)',
                                html: '<strong>étudiant(e) international(e)</strong>',
                            },
                        },
                        2: {
                            1: {
                                text: 'Canadian citizen born in Québec',
                                html: '<strong>canadian citizen born in Québec</strong>',
                            },
                            2: {
                                text: 'Canadian citizen born in a province other than Québec',
                                html: '<strong>canadian citizen born in a province other than Québec</strong>',
                            },
                            3: {
                                text: 'Permanent Resident',
                                html: '<strong>permanent resident</strong>',
                            },
                            4: {
                                text: 'Canadian citizen born outside Canada',
                                html: '<strong>canadian citizen born outside Canada</strong>',
                            },
                            5: {
                                text: 'International student',
                                html: '<strong>international student</strong>',
                            },
                        },
                    }
                }
            },
            mounted() {
                // console.log('AdmissionV2 module mounted');
            },
            computed: {
                admissionTypes() {
                    return this.admissionTypeChoices[this.siteId]
                },
                admissionStatuses() {
                    return this.admissionStatusChoices[this.siteId]
                }
            },
        })

        app.mount(self.el)
    }

    destroy(){
    }
}
